import type { HullId } from "@frontier/content/definitions";

export const HULL_ART: Record<HullId, { src: string; length: number }> = {
  assault: { src: "/assets/player-heavy.png", length: 84 },
  interceptor: { src: "/assets/player.png", length: 68 },
  engineer: { src: "/assets/hulls/engineer.png", length: 82 },
  scout: { src: "/assets/hulls/scout.png", length: 70 },
  transport: { src: "/assets/hulls/transport.png", length: 132 },
  bastion: { src: "/assets/hulls/bastion.png", length: 100 },
  hawk: { src: "/assets/hulls/hawk.png", length: 100 },
  aerie: { src: "/assets/hulls/aerie.png", length: 100 },
  arrow: { src: "/assets/hulls/arrow.png", length: 100 },
  argosy: { src: "/assets/hulls/argosy.png", length: 100 },
  leviathan: { src: "/assets/hulls/leviathan.png", length: 125 },
  quicksilver: { src: "/assets/hulls/quicksilver.png", length: 125 },
  falcon: { src: "/assets/hulls/falcon.png", length: 125 },
  clipper: { src: "/assets/hulls/clipper.png", length: 125 },
  behemoth: { src: "/assets/hulls/behemoth.png", length: 125 },
};

export const HULL_DISPLAY_ART: Record<HullId, string> = {
  assault: "/assets/hangar/assault.png",
  interceptor: "/assets/hangar/interceptor.png",
  engineer: "/assets/hangar/engineer.png",
  scout: "/assets/hangar/scout.png",
  transport: "/assets/hangar/transport.png",
  bastion: "/assets/hangar/bastion.png",
  hawk: "/assets/hangar/hawk.png",
  aerie: "/assets/hangar/aerie.png",
  arrow: "/assets/hangar/arrow.png",
  argosy: "/assets/hangar/argosy.png",
  leviathan: "/assets/hangar/leviathan.png",
  quicksilver: "/assets/hangar/quicksilver.png",
  falcon: "/assets/hangar/falcon.png",
  clipper: "/assets/hangar/clipper.png",
  behemoth: "/assets/hangar/behemoth.png",
};

export const HULL_DISPLAY_ASPECT: Record<HullId, number> = {
  assault: 280 / 220,
  interceptor: 300 / 240,
  engineer: 260 / 260,
  scout: 320 / 280,
  transport: 400 / 360,
  bastion: 440 / 360,
  hawk: 320 / 240,
  aerie: 384 / 320,
  arrow: 340 / 340,
  argosy: 360 / 340,
  leviathan: 440 / 380,
  quicksilver: 320 / 260,
  falcon: 520 / 440,
  clipper: 340 / 240,
  behemoth: 480 / 440,
};
